import React from 'react';
import queries from "../../../queries";
import {Mutation, Query} from "react-apollo";
import {backEndUri} from '../../../config';
import NeedAdmin from "../../NeedAdmin";
import {FormattedMessage} from "react-intl";
import PhotoboothCellStatsButton from "../PhotoboothCellStatsButton";
import PhotoboothCellPhotosZipButton from "../PhotoboothCellPhotosZipButton";

export default function PhotoboothCellEditor({cell, language}){

    console.log("PhotoboothCellEditor", cell);

    const [photoboothCell, setPhotoboothCell] = React.useState(cell);

    return(
        <Query query={queries.cells.photobooth.get} variables={{ id: cell.id }}>
            {({ loading, error, data }) => {
                if(loading) return null;
                if(error) return `Error!: ${error}`;
                if(data.photoboothCell) {
                    setPhotoboothCell(data.photoboothCell);
                }
                return(
                    <div>
                        <label>
                            Email
                        </label>
                        <Mutation refetchQueries={() => [{ query: queries.cells.photobooth.get, variables: {id: cell.id} }]} mutation={queries.cells.photobooth.update}>
                            {(updatePhotoboothCell) => {
                                return(
                                    <>
                                        <input type="checkbox" checked={photoboothCell.with_email} onChange={(e) => {
                                            setPhotoboothCell({
                                                ...photoboothCell,
                                                with_email: e.target.checked
                                            });
                                            updatePhotoboothCell({
                                                variables: {
                                                    input: {
                                                        id: cell.id,
                                                        with_email: e.target.checked,
                                                    }
                                                }
                                            });
                                        }}/>
                                    </>
                                );
                            }}
                        </Mutation><br/><br/>
                        <PhotoboothCellStatsButton cell={cell} />
                        <PhotoboothCellPhotosZipButton cell={cell} />
                    </div>
                );
            }}
        </Query>
    );
}
